/**
 * @name app.js
 */

// library
import * as THREE from "three";
import { gsap } from "gsap";

// webgl
import Webgl from "./Webgl";

// app
async function App(world) {

    let webgl = null;

    /**
     * @name Color
     */
    const color = {
        white: 0xFFFFFF,
        black: 0x000000,
        gray: 0x6D6D6D,
    }

    /**
     * @name Params
     */
    const params = {
        // 色
        color: color,
        alpha: 1.0,
        // サイズ
        size: {
            w: window.innerWidth,
            h: window.innerHeight,
            aspect: window.innerWidth / window.innerHeight,
            pos: 0,
        },
        options: {
            iterationsPoisson: 32,
            iterationsViscous: 32,
            mouseForce: 40,
            resolution: 0,
            cursorSize: 60,
            viscous: 30,
            isBounce: true,
            dt: 0.004,
            isViscous: true,
            BFECC: true,
        }
    }

    /**
     * @name updateSize
     * @param {boolean} isInit - 初期化かどうかを示すフラグ
     */
    const updateSize = (isInit = false) => {
        params.size.w = window.innerWidth;
        params.size.h = window.innerHeight;

        params.size.aspect = params.size.w / params.size.h;
        params.options.resolution = window.innerWidth > 1920 ? 0.3 : 0.5;

        // PC以外の場合、アドレスバーの分だけ高さを調整
        if (UA.data.device != "pc") {
            params.size.h = screen.height;
            params.size.pos = (screen.height - window.innerHeight) / -2 + "px";
        }

        if (!isInit) {
            webgl.__resize(params);
        }
    }

    /**
     * @name init
     */
    const init = () => {
        updateSize(true);
        webgl = new Webgl(world, params);
        initWebGL(webgl);
    }

    /**
     * @name initWebGL
     * @param {*} webgl - WebGLクラス 
     */
    const initWebGL = (webgl) => {
        /**
         * @name raf
         */
        const raf = () => {
            webgl.__raf();
        }

        /**
         * @name resize
         */
        const resize = () => {
            const resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (entry.contentRect.width !== previousWidth || entry.contentRect.height !== previousHeight) {
                        previousWidth = entry.contentRect.width;
                        previousHeight = entry.contentRect.height;
                        setTimeout(() => updateSize(), 300);
                    }
                }
            });

            let previousWidth = world.clientWidth;
            let previousHeight = world.clientHeight;

            resizeObserver.observe(world);
        }

        // フォントの読み込みが完了したら初期化
        document.fonts.ready.then(() => {
            webgl.__init();
            gsap.ticker.add(raf);
        });

        // リサイズ
        window.addEventListener('resize', resize);
    }

    // 初期化
    init();
}

export { App };